import { useCallback } from 'react';
import { Button, type ButtonProps, type ColorlessIconProps, IconYandexLogo } from '@direct-frontend/components';
import { trackGoal } from '@/entities/trackGoal';
import { passportAuthenticate } from '@/shared/lib/passportAuthenticate';
import { getRequestContext } from '@/shared/lib/requestContext';

export const LoginButton = (props: Partial<ButtonProps>) => {
    const { account, yandexPassportEnv } = getRequestContext();
    const onAuthenticate = useCallback(() => {
        trackGoal('oneclick_order_click');
        passportAuthenticate(yandexPassportEnv);
    }, [yandexPassportEnv]);

    const iconRight = useCallback(() => <span />, []);

    if (account.loggedIn) {
        return null;
    }

    return (
        <Button
            {...props}
            size="m"
            width="max"
            color="normal"
            title="Заказать в один клик через Яндекс"
            iconRight={iconRight}
            iconLeft={(props: ColorlessIconProps) => <IconYandexLogo {...props} size="24" />}
            onClick={onAuthenticate}
        >
            Заказать в один клик через Яндекс
        </Button>
    );
};
